<template lang="pug">
#filters-wrapper
  b-row(:class="{ 'mt-2': isDemoUser }")
    //- Custom Filters
    b-col(md="12", class="pb-2 pl-0 pr-0", v-if="customFiltersShow && isOnline")
      .d-flex.align-items-center
        b-col(md="4", class="pl-1 pr-1",)
          v-select(
            v-model="customFilter"
            label="name",
            :options="customFilterOptions",
            :placeholder="$t('custom_filters')"
          )
        b-col(md="4", class="pl-1 pr-1")
          b-button(
            block 
            variant="primary"
            :disabled="isButtonEnabled"
            @click="showModal('save')"
          ) {{ windowWidth <= 904 ? $t('message.save') : $t('message.save_custom_filter') }}
        b-col(md="4", class="px-0", v-if="customFiltersShow")
          trash-button(@clicked="deleteAllFilters", v-b-tooltip.hover.v-warning.top="$t('clear_filters')")
          delete-button(
            v-if="customFilter && userData.role === 'consultant'"
            @clicked="showModal('deleted')",
            v-b-tooltip.hover.v-danger.top="$t('delete_custom_filter')"
          )
        b-modal(
          ref="filterModal"
          centered
          no-close-on-backdrop
          modal-class="modal-success"
          ok-variant="success"
          cancel-variant="outline-secondary"
          :title="$t('message.save_custom_filter')"
          :ok-title="$t('message.save')"
          :cancel-title="$t('message.cancel')"
          :ok-disabled="!newCustomFilter"
          @hidden="resetModal"
          @ok="saveCustomFilters"
        )
          | {{ $t('message.name_custom_filter') }}
          div.pt-2
            b-form-input(v-model="newCustomFilter")
            small.text-danger(v-if="!newCustomFilter") {{ $t('message.name_required') }}
        b-modal(
          ref="deletedfilterModal"
          centered
          no-close-on-backdrop
          modal-class="modal-danger"
          ok-variant="danger"
          cancel-variant="outline-secondary"
          :title="$t('message.confirm_action')"
          :ok-title="$t('message.delete')"
          :cancel-title="$t('message.cancel')"
          @ok="deleteCustomFilter"
        )
          | {{ $t('message.confirm_delete_custom_filter') }}

    //- Zone
    b-col(md="4", class="pb-2", v-if="zoneFilterShow")
      v-select(
        v-model="zoneFilter",
        :multiple="true",
        :options="metadataFilterOptions.zone",
        :placeholder= "$t('zone_filter')"
      )

    //- Agency
    b-col(md="4", class="pb-2", v-if="agencyFilterShow && !commitmentFunctionality")
      v-select(
        v-model="agencyFilter",
        :multiple="true",
        :options="metadataFilterOptions.agency",
        :placeholder= "$t('agency_filter')"
      )

    //- Physical Location
    b-col(md="4", class="pb-2", v-if="physicalLocationFilterShow")
      v-select(
        v-model="physicalLocationFilter",
        :reduce="(physical_locations) => physical_locations.value",
        :multiple="true",
        label="title",
        :options="physical_locations",
        :placeholder="$t(physicalLocationFilterPlaceholder)",
      )

    //- Area
    b-col(md="4", class="pb-2", v-if="areaFilterShow")
      v-select(
        v-model="areaFilter",
        :reduce="(areas) => areas.value",
        :multiple="true",
        label="title",
        :options="areas",
        :placeholder="$t(areaFilterPlaceholder)",
      )
      small.text-secondary(v-if="areaFilterShow")
        | {{ areaWarning }}

    //- Location (Department)
    b-col(md="4", class="pb-2", v-if="locationFilterShow")
      v-select(
        v-model="locationFilter",
        :reduce="(locations) => locations.value",
        :multiple="true",
        label="title",
        :options="filteredLocations",
        :placeholder="$t(locationFilterPlaceholder)",
      )

    //- Duplicated filters (in case one module needs to filter by created_by and another by assigned_to, for example)
    //- Physical Location 2
    b-col(md="4", class="pb-2", v-if="physicalLocationFilter2Show")
      v-select(
        v-model="physicalLocationFilter2",
        :reduce="(physical_locations) => physical_locations.value",
        :multiple="true",
        label="title",
        :options="physical_locations",
        :placeholder="$t(physicalLocationFilter2Placeholder)",
      )

    //- Location (Department) 2
    b-col(md="4", class="pb-2", v-if="locationFilter2Show")
      v-select(
        v-model="locationFilter2",
        :reduce="(locations) => locations.value",
        :multiple="true",
        label="title",
        :options="filteredLocations2",
        :placeholder="$t(locationFilterFilter2Placeholder)",
      )

    //- Area 2
    b-col(md="4", class="pb-2", v-if="areaFilter2Show")
      v-select(
        v-model="areaFilter2",
        :reduce="(areas) => areas.value",
        :multiple="true",
        label="title",
        :options="areas",
        :placeholder="$t(areaFilter2Placeholder)",
      )

    //- QR destinationQRFilter
    b-col(md="4", class="pb-2", v-if="qrDestinationFiltersShow")
      v-select(
        v-model="destinationQRFilter",
        :reduce="(qrOptions) => qrOptions.value",
        label="title",
        :multiple="true",
        :options="qrOptions",
        :placeholder= "$t('message.qrDestination')"
      )

    //- Role
    b-col(md="4", class="pb-2", v-if="roleFilterShow")
      v-select(
        v-model="roleFilter",
        :reduce="(roles) => roles.value",
        :multiple="true",
        label="title",
        :options="roles",
        :placeholder="$t('role_filter')",
      )

    //- Process
    b-col(md="4", class="pb-2", v-if="processFilterShow")
      v-select(
        v-model="processFilter",
        :reduce="(processes) => processes.value",
        :multiple="true",
        label="title",
        :options="processes",
        :placeholder="$t('process_filter')",
      )

    //- Worker
    b-col(md="4", class="pb-2", v-if="workerFilterShow")
      v-select(
        v-model="workerFilter",
        :reduce="(workersSupervised) => workersSupervised.value",
        :multiple="true",
        label="title",
        :options="includeNoAssigneeOption ? workersSupervisedWithNoAssigneeOption : workersSupervised",
        :placeholder="$t(workerFilterPlaceholder)",
      )

    //- Supervisor
    b-col(md="4", class="pb-2", v-if="supervisorFilterShow")
      v-select(
        v-model="supervisorFilter",
        :reduce="(supervisors) => supervisors.value",
        :multiple="true",
        label="title",
        :options="supervisors",
        :placeholder="$t(supervisorFilterPlaceholder)",
      )
    //- Origin
    b-col(md="4", class="pb-2", v-if="originImprovementFilterShow")
      v-select(
        v-model="originFilter",
        :reduce="(originOptions) => originOptions.value",
        label="title",
        :options="originOptions",
        :placeholder="$t('origin_filter')",
      )
    //- Month
    b-col(md="4", class="pb-2", v-if="monthFilterShow")
      v-select(
        v-model="monthFilter",
        :reduce="(months) => months.value",
        label="title",
        :options="months",
        :placeholder="$t('month_filter')",
      )

    //- Year
    b-col(md="4", class="pb-2", v-if="yearFilterShow")
      v-select(
        v-model="yearFilter",
        :options="years",
        :placeholder="$t('year_filter')",
      )

    //- Date range
    b-col(:md="resetDateButtonShow ? '3' : '4'", :class="`pb-2 ${resetDateButtonShow ? 'pr-0' : ''}`", v-if="dateRangeFilterShow")
      flat-pickr(
        v-model="dateRangeFilter",
        class="form-control",
        :config="datePickerConfig",
        :placeholder="$t(dateRangePlaceholder)",
      )
    b-col(md="1", class="pb-2 pl-0", v-if="resetDateButtonShow")
      trash-button(@clicked="resetDate", v-b-tooltip.hover.v-warning.top="$t('clear_date_filter')")

    
    //- Metadata of type 'select'
    b-col(md="4", class="pb-2", v-if="metadataFilterShow")
      v-select(
        v-model="metadataFilter",
        :reduce="(metadata) => metadata.value",
        label="title",
        :options="metadataTypeSelect.value",
        :placeholder="$t('metadata_filter')",
      )

    //- Metadata filters for continuous improvement tab
    //- Instance
    b-col(md="4", class="pb-2", v-if="instanceFilterShow")
      v-select(
        v-model="instanceFilter",
        :multiple="true",
        :options="optionsMetadata.instance",
        :placeholder="$t('instance_filter')",
      )
    //- Instance Leader
    b-col(md="4", class="pb-2", v-if="instanceLeaderFilterShow")
      v-select(
        v-model="instanceLeaderFilter",
        :multiple="true",
        :options="optionsMetadata.instance_leader",
        :placeholder="$t('instance_leader_filter')",
      )
    //- Zone
    b-col(md="4", class="pb-2", v-if="zoneImprovementFilterShow")
      v-select(
        v-model="zoneImprovementFilter",
        :multiple="true",
        :options="optionsMetadata.zone",
        :placeholder="$t('zone_filter')",
      )
</template>

<script>
import { onMounted, ref, watch, computed, onBeforeUnmount} from '@vue/composition-api'
import vSelect from 'vue-select'
import useCommon from '@/views/organization/useCommon'
import i18n from "@/libs/i18n"
import flatPickr from "vue-flatpickr-component"
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton'
import TrashButton from '@/views/components/Shared/Buttons/TrashButton'
import { VBTooltip } from 'bootstrap-vue'
import store from '@/store'
import { EventBus } from "@/views/habit/EventBus.js"
import useNotifications from '@/composables/useNotifications'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default {
  components: {
    vSelect,
    flatPickr,
    DeleteButton,
    TrashButton
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    locationFilterShow: {
      type: Boolean,
      default: false
    },
    physicalLocationFilterShow: {
      type: Boolean,
      default: false
    },
    qrDestinationFiltersShow: {
      type: Boolean,
      default: false
    },
    areaFilterShow: {
      type: Boolean,
      default: false
    },
    roleFilterShow: {
      type: Boolean,
      default: false
    },
    processFilterShow: {
      type: Boolean,
      default: false
    },
    workerFilterShow: {
      type: Boolean,
      default: false
    },
    supervisorFilterShow: {
      type: Boolean,
      default: false
    },
    supervisorFilterPlaceholder: {
      type: String,
      default: 'supervisor_filter'  // i18n variable
    },
    monthFilterShow: {
      type: Boolean,
      default: false
    },
    yearFilterShow: {
      type: Boolean,
      default: false
    },
    dateRangeFilterShow: {
      type: Boolean,
      default: false
    },
    calendarMonth: {
      type: Number,
    },
    calendarYear: {
      type: Number,
    },
    dateRangeDaysLimit: {
      type: Number,
      default: 90
    },
    resetDateButtonShow: {
      type: Boolean,
      default: false
    },
    instanceFilterShow: {
      type: Boolean,
      default: false
    },
    instanceLeaderFilterShow: {
      type: Boolean,
      default: false
    },
    zoneImprovementFilterShow: {
      type: Boolean,
      default: false
    },
    zoneFilterShow: {
      type: Boolean,
      default: false
    },
    agencyFilterShow: {
      type: Boolean,
      default: false
    },
    metadataFilterShow: {
      type: Boolean,
      default: false
    },
    locationDefaultValue: {
      type: Boolean,
      default: false
    },
    workerDefaultValue: {
      type: String,
      default: ""
    },
    customFiltersShow: {
      type: Boolean,
      default: false
    },
    originImprovementFilterShow: {
      type: Boolean,
      default: false
    },
    origin: {
      type: String,
      default: ''
    },
    dateRangePlaceholder: {
      type: String,
      default: 'due_date_filter'
    },
    locationFilter2Show: {
      type: Boolean,
      default: false
    },
    physicalLocationFilter2Show: {
      type: Boolean,
      default: false
    },
    areaFilter2Show: {
      type: Boolean,
      default: false
    },
    physicalLocationFilterPlaceholder: {
      type: String,
      default: 'physical_location_filter'  // i18n variable
    },
    locationFilterPlaceholder: {
      type: String,
      default: 'location_filter'  // i18n variable
    },
    areaFilterPlaceholder: {
      type: String,
      default: 'area_filter'  // i18n variable
    },
    physicalLocationFilter2Placeholder: {
      type: String,
      default: 'physical_location_filter'  // i18n variable
    },
    locationFilterFilter2Placeholder: {
      type: String,
      default: 'location_filter'  // i18n variable
    },
    areaFilter2Placeholder: {
      type: String,
      default: 'area_filter'  // i18n variable
    },
    workerFilterPlaceholder: {
      type: String,
      default: 'worker_filter'  // i18n variable
    },
    includeNoAssigneeOption: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    
    const { getRolesForDropDown, roles, getSupervisorsForDropDown, supervisors, getLocationsForDropDown, locationsWithPhysicalLocation: locations, getPhysicalLocationsForDropDown, physical_locations, getAreasForDropDown, areas, getProcessesForDropDown, processes, getWorkersSupervisedForDropDown, workersSupervised, workersSupervisedWithNoAssigneeOption, getMetadataForDropDown, metadataFilterOptions, metadataTypeSelect, customFilterOptions, getCustomFilterForDropDown } = useCommon()
    const { showSuccessMessage } = useNotifications()
    const { createItem, updateItem, getItems } = useLambda()
    const userData = store.state?.userStore?.userData
    const userLocations = userData.locations?.length ? userData.locations : null
    const { default_language } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const commitmentFunctionality = JSON.parse(localStorage.getItem("clientData") || '{}').commitment_functionality
    const locationFilter = ref(props.locationDefaultValue && userLocations ? userLocations.map(e => e.value) : [])
    const physicalLocationFilter = ref([])
    const areaFilter = ref([])
    const locationFilter2 = ref([])
    const physicalLocationFilter2 = ref([])
    const areaFilter2 = ref([])
    const roleFilter = ref([])
    const processFilter = ref([])
    const workerFilter = ref(props.workerDefaultValue ? [props.workerDefaultValue] : [])
    const supervisorFilter = ref([])
    const instanceFilter = ref([])
    const instanceLeaderFilter = ref([])
    const zoneImprovementFilter = ref([])
    const isDatePickerOpen = ref(false)
    const optionsMetadata = computed(() => store.state["app-todo"].optionsMetadata)
    const zoneFilter = ref([])
    const agencyFilter = ref([])
    const metadataFilter = ref("")
    const windowWidth = ref(window.innerWidth)
    const isOnline = computed(() => store.state.app.isOnline)
    const filterModal = ref(null)
    const deletedfilterModal = ref(null)
    const isButtonEnabled = ref(true)
    const customFilter = ref(null)
    const customFilterActive = ref(false)
    const newCustomFilter = ref(null)
    const { project } = JSON.parse(localStorage.getItem('userData') || '{}')
    const isDemoUser = project?.startsWith("demoUser")
    const collection = 'custom_filter'
    const originFilter = ref('')
    const destinationQRFilter = ref('')
    const originOptions = computed(() => {
      if (props.origin === 'commitment') {
        return [
          { title: `${i18n.t('improvement')} – ${i18n.t('message.direct')}`,value: 'direct'},
          { title: `${i18n.t('improvement')} – ${i18n.t('message.daily_dialogue')}`, value: 'daily_dialogue'},
          { title: i18n.t('Confirmation'), value: 'confirmation' },
        ]
      }
      return [
        { title: i18n.t('message.direct'), value: 'direct' },
        { title: i18n.t('message.daily_dialogue'), value: 'daily_dialogue' },
        // { title: i18n.t('message.AI assistance'), value: 'AI assistance' },
        // { title: i18n.t('message.confirmation'), value: 'confirmation' },
      ]
    })
    const qrOptions = ref([
      { title: i18n.t('label.employee-survey'), value: 'employee-survey' },
      { title: i18n.t('label.customer-survey'), value: 'customer-survey' },
      { title: i18n.t('label.barometer-survey'), value: 'barometer-survey' }
    ])

    const datePickerConfig = ref({
      mode: "range",
      dateFormat: default_language === "en" ? "m-d-Y" : "d-m-Y",
      minDate: null,
      maxDate: null,
      onOpen: function(selectedDates, dateStr, instance) {
        isDatePickerOpen.value = true
      },
      onClose: function(selectedDates, dateStr, instance) {
        isDatePickerOpen.value = false
      },
      onChange: function(selectedDates, dateStr, instance) {
        if (!isDatePickerOpen.value) emitChangeFilter()
      },
      errorHandler: function(error) {
        // Don't show error message in console if date has been cleared
        if (dateRangeFilter.value) console.log(error)
      }
    })

    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()
    const currentDay = now.getDate()
    const lastDayOfMonthDate = new Date(currentYear, currentMonth + 1, 0)
    const lastDayOfMonthNumber = lastDayOfMonthDate.getDate()
    const oneYearBeforeDate = new Date(currentYear, currentMonth, currentDay - 365)

    const months = computed(() => {
      return [
        { title: i18n.t('month.january'), value: 1 },
        { title: i18n.t('month.february'), value: 2 },
        { title: i18n.t('month.march'), value: 3 },
        { title: i18n.t('month.april'), value: 4 },
        { title: i18n.t('month.may'), value: 5 },
        { title: i18n.t('month.june'), value: 6 },
        { title: i18n.t('month.july'), value: 7 },
        { title: i18n.t('month.august'), value: 8 },
        { title: i18n.t('month.september'), value: 9 },
        { title: i18n.t('month.october'), value: 10 },
        { title: i18n.t('month.november'), value: 11 },
        { title: i18n.t('month.december'), value: 12 }
      ]
    })

    let years = []
    for (let i = 2022; i < currentYear + 2; i++) {
      years.push(i)
    }

    const monthFilter = ref(currentMonth + 1)
    const yearFilter = ref(currentYear)
    const dateRangeFilter = props.resetDateButtonShow
      ? ref("")
      : props.dateRangeDaysLimit === 365
        ? default_language === "en"
          ? ref(`${oneYearBeforeDate.getMonth() + 1}-${oneYearBeforeDate.getDate()}-${oneYearBeforeDate.getFullYear()} to ${currentMonth + 1}-${currentDay}-${currentYear}`)
          : ref(`${oneYearBeforeDate.getDate()}-${oneYearBeforeDate.getMonth() + 1}-${oneYearBeforeDate.getFullYear()} to ${currentDay}-${currentMonth + 1}-${currentYear}`)
        : default_language === "en"
          ? ref(`${currentMonth + 1}-01-${currentYear} to ${currentMonth + 1}-${lastDayOfMonthNumber}-${currentYear}`)
          : ref(`01-${currentMonth + 1}-${currentYear} to ${lastDayOfMonthNumber}-${currentMonth + 1}-${currentYear}`)

    const initialDateRangeFilter = JSON.parse(JSON.stringify(dateRangeFilter.value))
  
    watch(() => props.calendarMonth, (newVal) => {
      monthFilter.value = newVal + 1
    })

    watch(() => props.calendarYear, (newVal) => {
      yearFilter.value = newVal
    })

    // Compares two arrays of strings for equality, ignoring order
    const areStringArraysEqual = (a, b) => {
      if (!Array.isArray(a) || !Array.isArray(b)) return false;
      if (a.length !== b.length) return false;
      const sortedA = [...a].sort();
      const sortedB = [...b].sort();
      return sortedA.every((val, index) => val === sortedB[index]);
    }

    // Strategy to prevent emitChangeFilter() from running when filters haven't actually changed:
    // 1- The previous state is stored in lastFilterState
    let lastFilterState = { locationFilter: [], physicalLocationFilter: [], areaFilter: [], originFilter: [], destinationQRFilter: [], roleFilter: [], processFilter: [], workerFilter: [],supervisorFilter: [], monthFilter: null, yearFilter: null, instanceFilter: null, instanceLeaderFilter: null, zoneImprovementFilter: null, zoneFilter: null, agencyFilter: null, metadataFilter: null, locationFilter2: [], physicalLocationFilter2: [], areaFilter2: [] }

    watch([ locationFilter, physicalLocationFilter, areaFilter, originFilter, destinationQRFilter, roleFilter, processFilter, workerFilter, supervisorFilter, monthFilter, yearFilter, instanceFilter, instanceLeaderFilter, zoneImprovementFilter, zoneFilter, agencyFilter, metadataFilter, locationFilter2, physicalLocationFilter2, areaFilter2 ], () => {
      
      // 2- Compared with the current state using areStringArraysEqual.
      const hasChanged =
        !areStringArraysEqual(lastFilterState.locationFilter, locationFilter.value) ||
        !areStringArraysEqual(lastFilterState.physicalLocationFilter, physicalLocationFilter.value) ||
        !areStringArraysEqual(lastFilterState.areaFilter, areaFilter.value) ||
        !areStringArraysEqual(lastFilterState.originFilter, originFilter.value) ||
        !areStringArraysEqual(lastFilterState.destinationQRFilter, destinationQRFilter.value) ||
        !areStringArraysEqual(lastFilterState.roleFilter, roleFilter.value) ||
        !areStringArraysEqual(lastFilterState.processFilter, processFilter.value) ||
        !areStringArraysEqual(lastFilterState.workerFilter, workerFilter.value) ||
        !areStringArraysEqual(lastFilterState.supervisorFilter, supervisorFilter.value) ||
        !areStringArraysEqual(lastFilterState.locationFilter2, locationFilter2.value) ||
        !areStringArraysEqual(lastFilterState.physicalLocationFilter2, physicalLocationFilter2.value) ||
        !areStringArraysEqual(lastFilterState.areaFilter2, areaFilter2.value) ||
        lastFilterState.monthFilter !== monthFilter.value ||
        lastFilterState.yearFilter !== yearFilter.value ||
        lastFilterState.instanceFilter !== instanceFilter.value ||
        lastFilterState.instanceLeaderFilter !== instanceLeaderFilter.value ||
        lastFilterState.zoneImprovementFilter !== zoneImprovementFilter.value ||
        lastFilterState.zoneFilter !== zoneFilter.value ||
        lastFilterState.agencyFilter !== agencyFilter.value ||
        lastFilterState.metadataFilter !== metadataFilter.value;
      
      // 3- If no changes are detected, the watcher exits early.
      if (!hasChanged) return

      // 4- If changes are found, lastFilterState is updated and the rest of the logic proceeds.
      lastFilterState = {
        locationFilter: [...locationFilter.value],
        physicalLocationFilter: [...physicalLocationFilter.value],
        areaFilter: [...areaFilter.value],
        originFilter: [...originFilter.value],
        destinationQRFilter: [...destinationQRFilter.value],
        roleFilter: [...roleFilter.value],
        processFilter: [...processFilter.value],
        workerFilter: [...workerFilter.value],
        supervisorFilter: [...supervisorFilter.value],
        monthFilter: monthFilter.value,
        yearFilter: yearFilter.value,
        instanceFilter: instanceFilter.value,
        instanceLeaderFilter: instanceLeaderFilter.value,
        zoneImprovementFilter: zoneImprovementFilter.value,
        zoneFilter: zoneFilter.value,
        agencyFilter: agencyFilter.value,
        metadataFilter: metadataFilter.value,
        locationFilter2: [...locationFilter2.value],
        physicalLocationFilter2: [...physicalLocationFilter2.value],
        areaFilter2: [...areaFilter2.value],
      }

      const customFilterL = customFilter.value?.locations || []
      const customFilterPh = customFilter.value?.physical_locations || []
      const customFilterA = customFilter.value?.areas || []
      const customFilterP = customFilter.value?.process || []
      const customFilterR = customFilter.value?.role || []
      const customFilterW = customFilter.value?.worker || []
      const customFilterS = customFilter.value?.supervisor || []
      const customFilterO = customFilter.value?.origin || ''
      const customFilterD = customFilter.value?.destination || ''

      if (customFilterActive.value) {
        if (customFilterL?.length !== locationFilter.value?.length || customFilterPh?.length !== physicalLocationFilter.value?.length || customFilterA?.length !== areaFilter.value?.length || customFilterO?.length !== originFilter.value?.length || customFilterD?.length !== destinationQRFilter.value?.length || customFilterP?.length !== processFilter.value?.length || customFilterR?.length !== roleFilter.value?.length || customFilterW?.length !== workerFilter.value?.length || customFilterS?.length !== supervisorFilter.value?.length) {
          customFilter.value = null
          customFilterActive.value = false
          isButtonEnabled.value = false
        }
      }

      emitChangeFilter()
    })

    watch(customFilter, () => {
      customFilterActive.value = true
      if (customFilter.value) {
        locationFilter.value = customFilter.value.locations || []
        physicalLocationFilter.value = customFilter.value.physical_locations || []
        areaFilter.value = customFilter.value.areas || []
        originFilter.value = customFilter.value.origin || ''
        destinationQRFilter.value = destinationQRFilter.value.destination || ''
        processFilter.value = customFilter.value.process || []
        roleFilter.value = customFilter.value.role || []
        supervisorFilter.value = customFilter.value.supervisor || []
        workerFilter.value = customFilter.value.worker || []
      }
    })

    const changeDateRangeFormat = (range) => {
      if (!range) return range
      const datesArray = range.split(" ")
      const dashSeparator = datesArray[0][2] === "-" || datesArray[0][1] === "-"
      let startArray = dashSeparator ? datesArray[0].split("-") : datesArray[0].split("/")
      startArray = [startArray[1], startArray[0], startArray[2]].join(dashSeparator ? "-" : "/")
      if (!datesArray[2]) return startArray
      let endArray = dashSeparator ? datesArray[2].split("-") : datesArray[2].split("/")
      endArray = [endArray[1], endArray[0], endArray[2]].join(dashSeparator ? "-" : "/")
      return `${startArray} ${datesArray[1]} ${endArray}`
    }

    // Store the list of location IDs added via physicalLocationFilter and areaFilter
    let lastInjectedLocationIdsFromArea = []
    const areaWarning = ref('')

    const emitChangeFilter = () => {
      if (isButtonEnabled.value) isButtonEnabled.value = false

      // const hasPhysicalFilter = physicalLocationFilter.value.length > 0
      const hasAreaFilter = areaFilter.value.length > 0
      const hasAllLocations = allLocations.value.length > 0

      // physicalLocationWarning.value = ''
      areaWarning.value = ''

      // Reset filters if removed
      const resetFilter = (lastInjected, filterRef) => {
        if (lastInjected.length > 0 && lastInjected.some(id => !locationFilter.value?.includes(id))) {
          filterRef.value = []
          return true
        }
        return false
      }

      // if (resetFilter(lastInjectedLocationIdsFromPhysical, physicalLocationFilter)) lastInjectedLocationIdsFromPhysical = []
      if (resetFilter(lastInjectedLocationIdsFromArea, areaFilter)) lastInjectedLocationIdsFromArea = []

      if (hasAreaFilter && hasAllLocations) {
        // --- Combine filters into newLocationArray ---
        const filterLocations = (filterFn) => allLocations.value.filter(filterFn).map(loc => loc._id?.toString())

        let newLocationArray = []
        if (hasAreaFilter) {
          newLocationArray = filterLocations(loc => {
            const inArea = areaFilter.value.includes(loc.area?.toString())
            const inPhysicalLocation = !physicalLocationFilter.value.length || physicalLocationFilter.value.includes(loc.physical_location?.toString())
            return inArea && inPhysicalLocation
          })
          lastInjectedLocationIdsFromArea = newLocationArray
        }

        // --- Helper to build warnings ---
        const buildWarning = (filterValues, associatedIds, allOptions, targetWarning) => {
          const missing = filterValues.filter(id => !associatedIds.value.includes(id))
          targetWarning.value = missing.length
            ? `${i18n.t('label.noAssocDepartments')} ${missing.map(id => allOptions.find(o => o.value === id)?.title || id).join(' - ')}`
            : ''
        }

        // Physical and Area warnings
        // if (hasPhysicalFilter) buildWarning(physicalLocationFilter.value, associatedPhysicalLocationIds, physical_locations.value, physicalLocationWarning)
        if (hasAreaFilter) buildWarning(areaFilter.value, associatedAreaIds, areas.value, areaWarning)

        // Update locationFilter only if changed
        if (!areStringArraysEqual(locationFilter.value, newLocationArray)) locationFilter.value = newLocationArray
      }

      emit('changeFilter', {
        locationFilter: locationFilter.value,
        physicalLocationFilter: physicalLocationFilter.value,
        roleFilter: roleFilter.value,
        processFilter: processFilter.value,
        workerFilter: workerFilter.value,
        supervisorFilter: supervisorFilter.value,
        monthFilter: monthFilter.value - 1,
        yearFilter: yearFilter.value,
        dateRangeFilter: default_language === "en" ? changeDateRangeFormat(dateRangeFilter.value) : dateRangeFilter.value,
        instanceFilter: instanceFilter.value,
        instanceLeaderFilter: instanceLeaderFilter.value,
        zoneImprovementFilter: zoneImprovementFilter.value,
        zoneFilter: zoneFilter.value,
        agencyFilter: agencyFilter.value,
        metadataFilter: metadataFilter.value,
        originFilter: originFilter.value,
        destinationQRFilter: destinationQRFilter.value,
        locationFilter2: locationFilter2.value,
        physicalLocationFilter2: physicalLocationFilter2.value,
        areaFilter2: areaFilter2.value,
      })

      const totalLength = [locationFilter, physicalLocationFilter, areaFilter, roleFilter, processFilter, supervisorFilter, locationFilter2, physicalLocationFilter2, areaFilter2]
        .reduce((acc, filter) => acc + filter.value?.length, 0)

      if (totalLength === 0 || totalLength === 1 || customFilter.value) {
        isButtonEnabled.value = true
      }
    }
    
      const deleteAllFilters = () => {
        locationFilter.value = []
        physicalLocationFilter.value = []
        areaFilter.value = []
        originFilter.value = ''
        destinationQRFilter.value = ''
        roleFilter.value = []
        processFilter.value = []
        workerFilter.value = []
        supervisorFilter.value = []
        customFilter.value = ""
        dateRangeFilter.value = initialDateRangeFilter
        locationFilter2.value = []
        physicalLocationFilter2.value = []
        areaFilter2.value = []
      }

    const resetModal = () => {
      newCustomFilter.value = ""
    }

    const saveCustomFilters = async () => {
      const customFilterName = newCustomFilter.value

      const customFilterData = {
        client_id: oid(userData.client.$oid),
        name: customFilterName,
        locations: locationFilter.value?.map(e => oid(e)) || [],
        physical_locations: physicalLocationFilter.value?.map(e => oid(e)) || [],
        areas: areaFilter.value?.map(e => oid(e)) || [],
        origin: originFilter.value || '',
        destination: destinationQRFilter.value || '',
        process: processFilter.value?.map(e => oid(e)) || [],
        role: roleFilter.value?.map(e => oid(e)) || [],
        worker: workerFilter.value?.map(e => oid(e)) || [],
        supervisor: supervisorFilter.value?.map(e => oid(e)) || []
      }

      try {
        const item = await createItem({ collection, payload: customFilterData })
        if (!item) throw new Error('Item not created')

        showSuccessMessage(i18n.t('message.custom_filter_created'))
        getCustomFilterForDropDown()

        customFilter.value = {
          _id: item.insertedId.toString(),
          name: customFilterName,
          locations: locationFilter.value,
          physical_locations: physicalLocationFilter.value,
          areas: areaFilter.value,
          origin: originFilter.value,
          destination: destinationQRFilter.value,
          process: processFilter.value,
          role: roleFilter.value,
          worker: workerFilter.value,
          supervisor: supervisorFilter.value
        }
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.something_went_wrong'))
      }
    }

    const deleteCustomFilter = async () => {
      try {
        const query = { _id: oid(customFilter.value._id) }
        const action = { $set: { deleted: true } }

        await updateItem({ collection, query, action })

        showSuccessMessage(i18n.t('message.custom_filter_removed'))
        getCustomFilterForDropDown()
        customFilter.value = null
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.something_went_wrong'))
      }
    }

    watch(dateRangeFilter, () => {
      // Limit the date range to the days limit received by props
      const datesArray = dateRangeFilter.value.split(" ")
      if (datesArray[2]) {
        datePickerConfig.value.minDate = null
        datePickerConfig.value.maxDate = null
      }
      else {
        const startArray = datesArray[0].split("-")
        const startDate = new Date(startArray[2], startArray[default_language === "en" ? 0 : 1] - 1, startArray[default_language === "en" ? 1 : 0])
        const startYear = startDate.getFullYear()
        const startMonth = startDate.getMonth()
        const startDay = startDate.getDate()
        const minDate = new Date(startYear, startMonth, startDay - props.dateRangeDaysLimit)
        const maxDate = new Date(startYear, startMonth, startDay + props.dateRangeDaysLimit)
        datePickerConfig.value.minDate = minDate
        datePickerConfig.value.maxDate = maxDate
      }
    })

    watch(locations, () => {
      emit('locations', locations.value)
    })

    watch(physical_locations, () => {
      emit('physical_locations', physical_locations.value)
    })

    watch(areas, () => {
      emit('areas', areas.value)
    })

    watch(supervisors, () => {
      emit('supervisors', supervisors.value)
    })

    watch(metadataTypeSelect, () => {
      if (metadataTypeSelect.value?.value?.length) {
        metadataFilter.value = metadataTypeSelect.value.value[0].value
        emit('setAddMetadataButtonStatus', true)
      }
      else {
        metadataFilter.value = ""
        emit('setAddMetadataButtonStatus', false)
      }
    })

    const showModal = (value) => {
      if(value === 'save') filterModal.value.show()
      else if(value === 'deleted') deletedfilterModal.value.show()
    }

    const resetDate = () => {
      dateRangeFilter.value = ""
    }

    const updateWindowWidth = () => {
      windowWidth.value = window.innerWidth;
    }

    const allLocations = ref([])

    const getAllLocation = async () => {
      const query = { client_id: oid(userData.client.$oid), deleted: { $ne: true } }
      try {
        allLocations.value = await getItems({ collection: 'location', query })
      } catch (error) {
        console.log(error)
      }
    }

    // const associatedPhysicalLocationIds = computed(() => {
    //   if (!allLocations.value?.length || !physical_locations.value?.length) return []
    //   const idsP = allLocations.value.map(loc => loc.physical_location?.toString()).filter(Boolean)
    //   const validIdsP = new Set(physical_locations.value.map(p => p.value))
    //   return [...new Set(idsP.filter(id => validIdsP.has(id)))]
    // })

    const associatedAreaIds = computed(() => {
      if (!allLocations.value?.length || !areas.value?.length) return []
      const idsA = allLocations.value.map(loc => loc.area?.toString()).filter(Boolean)
      const validIdsA = new Set(areas.value.map(a => a.value))
      return [...new Set(idsA.filter(id => validIdsA.has(id)))]
    })

    // Filtrar departamentos en base a la localidad seleccionada
    const filteredLocations = computed(() => {
      // Si no seleccionaron physical_locations → devolver todas
      if (!physicalLocationFilter.value.length) return locations.value

      // Filtrar locationFilter por si está seleccionado un departamento que no tiene relación con las localidades seleccionadas
      locationFilter.value = locationFilter.value.filter(locId => {
        const loc = locations.value.find(l => l.value === locId)
        return loc && physicalLocationFilter.value.includes(loc.physical_location)
      })

      return locations.value.filter(loc =>
        physicalLocationFilter.value.includes(loc.physical_location)
      )
    })

    // Filtrar departamentos en base a la localidad seleccionada
    const filteredLocations2 = computed(() => {
      // Si no seleccionaron physical_locations → devolver todas
      if (!physicalLocationFilter2.value.length) return locations.value

      // Filtrar locationFilter por si está seleccionado un departamento que no tiene relación con las localidades seleccionadas
      locationFilter2.value = locationFilter2.value.filter(locId => {
        const loc = locations.value.find(l => l.value === locId)
        return loc && physicalLocationFilter2.value.includes(loc.physical_location)
      })

      return locations.value.filter(loc =>
        physicalLocationFilter2.value.includes(loc.physical_location)
      )
    })

    onMounted(() => {
      window.addEventListener('resize', updateWindowWidth)
      getAllLocation()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateWindowWidth);
    })

    onMounted(() => {
      if (props.roleFilterShow) getRolesForDropDown()
      if (props.supervisorFilterShow) getSupervisorsForDropDown()
      if (props.locationFilterShow) getLocationsForDropDown()
      if (props.physicalLocationFilterShow) getPhysicalLocationsForDropDown()
      if (props.areaFilterShow) getAreasForDropDown()
      if (props.processFilterShow) getProcessesForDropDown()
      if (props.workerFilterShow) getWorkersSupervisedForDropDown(null, null, props.includeNoAssigneeOption)
      if (props.zoneFilterShow || props.agencyFilterShow) getMetadataForDropDown({category: "filter"})
      if (props.metadataFilterShow) getMetadataForDropDown({type: "select"})
      if (props.customFiltersShow) getCustomFilterForDropDown()
      if (props.locationFilter2Show) getLocationsForDropDown()
      if (props.physicalLocationFilter2Show) getPhysicalLocationsForDropDown()
      if (props.areaFilter2Show) getAreasForDropDown()
      
      // Filter data when a point from a chart is clicked
      EventBus.$on('filterByLocation', locationId => {
        locationFilter.value = locationFilter.value.length === 1 && locationFilter.value[0] === locationId
          ? []
          : [locationId]
      });
      EventBus.$on('filterByPhysicalLocation', physicalLocationId => {
        physicalLocationFilter.value = physicalLocationFilter.value.length === 1 && physicalLocationFilter.value[0] === physicalLocationId
          ? []
          : [physicalLocationId]
      });
      EventBus.$on('filterByProcess', processId => {
        processFilter.value = processFilter.value.length === 1 && processFilter.value[0] === processId
          ? []
          : [processId]
      });
      EventBus.$on('filterByWorker', workerId => {
        workerFilter.value = workerFilter.value.length === 1 && workerFilter.value[0] === workerId
          ? []
          : [workerId]
      });
      EventBus.$on('filterBySupervisor', supervisorId => {
        supervisorFilter.value = supervisorFilter.value.length === 1 && supervisorFilter.value[0] === supervisorId
          ? []
          : [supervisorId]
      });
      EventBus.$on('filterByDate', date => {
        dateRangeFilter.value = `${date} to ${date}`
      });
      EventBus.$on('filterBySupervisorAndProcess', (supervisorId, processId) => {
        const reset = supervisorFilter.value.length === 1 && supervisorFilter.value[0] === supervisorId && processFilter.value.length === 1 && processFilter.value[0] === processId
        supervisorFilter.value = reset || !supervisorId ? [] : [supervisorId]
        processFilter.value = reset || !processId ? [] : [processId]
      });
    })

    return {
      locationFilter,
      physicalLocationFilter,
      areaFilter,
      roleFilter,
      processFilter,
      workerFilter,
      supervisorFilter,
      monthFilter,
      yearFilter,
      dateRangeFilter,
      instanceFilter,
      instanceLeaderFilter,
      zoneImprovementFilter,
      locations,
      physical_locations,
      areas,
      roles,
      processes,
      workersSupervised,
      workersSupervisedWithNoAssigneeOption,
      supervisors,
      months,
      years,
      datePickerConfig,
      resetDate,
      optionsMetadata,
      zoneFilter,
      agencyFilter,
      metadataFilter,
      originFilter,
      metadataFilterOptions,
      metadataTypeSelect,
      windowWidth,
      isOnline,
      filterModal,
      showModal,
      isButtonEnabled,
      saveCustomFilters,
      customFilterOptions,
      customFilter,
      deleteAllFilters,
      deletedfilterModal,
      newCustomFilter,
      resetModal,
      deleteCustomFilter,
      userData,
      commitmentFunctionality,
      isDemoUser,
      originOptions,
      // physicalLocationWarning,
      areaWarning,
      qrOptions,
      destinationQRFilter,
      locationFilter2,
      physicalLocationFilter2,
      areaFilter2,
      filteredLocations,
      filteredLocations2,
    }
  },
}
</script>

<style lang="scss" scoped>

</style>